import { combineReducers } from "redux"
import getGrainElevatorAssessmentInfoReducer from "./getGrainElevatorAssessmentInfoReducer"
import putAssessmentInfoReducer from "./putAssessmentInfoReducer"

const grainElevatorAssessmentInfoReducer = combineReducers({
  getGrainElevatorAssessmentInfo: getGrainElevatorAssessmentInfoReducer,
  putAssessmentInfo: putAssessmentInfoReducer,
})

export default grainElevatorAssessmentInfoReducer